import * as React from 'react';
import { AuthApiError } from '../errors.js';
/**
 * Wraps an async function with loading + error tracking. The wrapped function
 * still rejects on error (so callers can `try/catch` and branch on the typed
 * error), but the latest error is also exposed for inline error messages.
 */
export function useAsyncAction(fn) {
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    const fnRef = React.useRef(fn);
    React.useEffect(() => {
        fnRef.current = fn;
    }, [fn]);
    const run = React.useCallback(async (...args) => {
        setLoading(true);
        setError(null);
        try {
            return await fnRef.current(...args);
        }
        catch (err) {
            // Preserve typed errors so consumers can branch on `code`; wrap unknown
            // throws into a generic Error to keep the state shape predictable.
            if (err instanceof AuthApiError)
                setError(err);
            else if (err instanceof Error)
                setError(err);
            else
                setError(new Error(String(err)));
            throw err;
        }
        finally {
            setLoading(false);
        }
    }, []);
    const reset = React.useCallback(() => setError(null), []);
    return { run, loading, error, reset };
}
//# sourceMappingURL=use-async-action.js.map